import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ChatTeamAdmin,
  ChatTeamMemberAdmin,
  ChatTeamMemberRequest,
  ChatTeamRequest
} from '../models/chat-team-admin.model';

/**
 * Administración de equipos de chat.
 *
 * Los GET de administración cuelgan de `/admin` para no chocar con el lookup de solo lectura
 * (`GET /api/chat-teams`), que alimenta los desplegables y solo devuelve los equipos activos.
 * Aquí sí interesan los inactivos: son los que hay que poder reactivar.
 */
@Injectable({ providedIn: 'root' })
export class ChatTeamAdminApiService {
  private readonly base = `${environment.apiUrl}api/chat-teams`;

  constructor(private http: HttpClient) {}

  getTeams(): Observable<ChatTeamAdmin[]> {
    return this.http.get<ChatTeamAdmin[]>(`${this.base}/admin`);
  }

  getTeamById(teamId: number): Observable<ChatTeamAdmin> {
    return this.http.get<ChatTeamAdmin>(`${this.base}/admin/${teamId}`);
  }

  createTeam(request: ChatTeamRequest): Observable<ChatTeamAdmin> {
    return this.http.post<ChatTeamAdmin>(this.base, request);
  }

  updateTeam(teamId: number, request: ChatTeamRequest): Observable<ChatTeamAdmin> {
    return this.http.put<ChatTeamAdmin>(`${this.base}/${teamId}`, request);
  }

  deleteTeam(teamId: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${teamId}`);
  }

  getMembers(teamId: number): Observable<ChatTeamMemberAdmin[]> {
    return this.http.get<ChatTeamMemberAdmin[]>(`${this.base}/admin/${teamId}/members`);
  }

  addMember(teamId: number, request: ChatTeamMemberRequest): Observable<ChatTeamMemberAdmin> {
    return this.http.post<ChatTeamMemberAdmin>(`${this.base}/${teamId}/members`, request);
  }

  updateMember(teamId: number, memberId: number, request: ChatTeamMemberRequest): Observable<ChatTeamMemberAdmin> {
    return this.http.put<ChatTeamMemberAdmin>(`${this.base}/${teamId}/members/${memberId}`, request);
  }

  removeMember(teamId: number, memberId: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${teamId}/members/${memberId}`);
  }
}
